import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, empty, throwError } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
import { CartItem, CheckOutDetail, ICartItem, ICheckOutProcessModel, BaseResponse } from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  constructor(private httpClient: HttpClient, private userService: UserService) { }
  public totalCartItem: BehaviorSubject<number> = new BehaviorSubject<number>(
    0
  );
  //#region CartService Api endPoints
  public getItems1() {
    const apiEndpoint = ConfigService.APIs.endPoints.CART.GET_ITEMS;
    const data = {     
      customerNumber: this.userService.readUserObject.customerNumber
    };
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public getItems(customerNumber: string): Observable<CartItem[]> {
    const apiEndpoint = ConfigService.APIs.endPoints.CART.GET_ITEMS;
    const data = {
      customerNumber: customerNumber
    };
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }), 
      map((response: BaseResponse) => response.data)
    );
  }
  public removeItem(cartId: string) {
    const apiEndpoint = ConfigService.APIs.endPoints.CART.REMOVE_ITEM;
    const data = { cartId };
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data) as Observable<any>;
  }
  public emptyCart() {
    const apiEndpoint = ConfigService.APIs.endPoints.CART.EMPTY_CART;
    const data = {
      customerNumber: this.userService.readUserObject.customerNumber
    };
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data) as Observable<any>;
  }
  public updateCart(item: ICartItem): Observable<any> {
    const apiEndpoint = ConfigService.APIs.endPoints.CART.UPDATE_ITEM;
    const data = [];
    //item.userId = this.userService.readUserObject.userId;
    item.customerNumber = this.userService.readUserObject.customerNumber
    data.push(item);
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data) as Observable<any>;
  }
  public addStockItem(item: ICartItem): Observable<any> {
    const apiEndpoint = ConfigService.APIs.endPoints.CART.ADD_STOCK_ITEM;
    const data = [];
    //item.userId = this.userService.readUserObject.userId;
    item.customerNumber = this.userService.readUserObject.customerNumber
    data.push(item);
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    ) as Observable<any>;
  }
  public addConfiguredItemToCart(data: ICartItem): Observable<any> {
    const apiEndpoint = ConfigService.APIs.endPoints.CART.ADD_CONFIGURED_ITEM_TO_CART;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data) as Observable<any>;
  }
  public uploadItems(data: ICartItem[]): Observable<any> {
    const apiEndpoint = ConfigService.APIs.endPoints.CART.UPLOAD_ITEMS;
    data.forEach(el => {
      //el.userId = this.userService.readUserObject.userId;
      el.customerNumber = this.userService.readUserObject.customerNumber
    })
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data) as Observable<any>;
  }
  public getItemCountInCart(): Observable<number> {
    const apiEndpoint = ConfigService.APIs.endPoints.CART.GET_CART_ITEM_COUNT;
    const data = {
      //userId: this.userService.readUserObject.userId,
      customerNumber: this.userService.readUserObject.customerNumber
    }
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
          catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
        tap((totalCartItem) => { this.totalCartItem.next(totalCartItem) }));;
  }
  public getCartDiscount() {
    const apiEndpoint = ConfigService.APIs.endPoints.CART.GET_CART_DISCOUNT;
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint)
      .pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data ),
      ) as Observable<any>;
  }
  // This will be Removed .
  public get listItems(): Array<any> {
    return [
      "door 1",
      1,
      "14 Clear",
      451,
      "No",
      '36"',
      '84"',
      350,
      "RHOS (LHR)",
      "Offset Pivot",
      "MS 1850",
    ];
  }

}
